import { createComponent } from '@carvana/vdp-components';

const commonClass = 'bg-grey-1 overflow-hidden';

export const VehicleInfoContainer = createComponent('div', {
  className: 'grid grid-cols-1 grid-rows-[44px_1fr_16px] px-16 py-12'
});

export const VehicleImage = createComponent('div', {
  className: 'bg-gradient-to-t from-[#EDF5F8] to-white via-white'
});

export const YearMakeModel = createComponent('span', {
  className: `${commonClass} h-24 w-[60%]`
});

export const TrimMileage = createComponent('span', {
  className: `${commonClass} h-20 w-[40%]`
});

export const Price = createComponent('span', {
  className: `${commonClass} h-28 w-[50%] mb-20`
});

export const MonthlyPayment = createComponent('span', {
  className: `${commonClass} h-20 w-80 mb-4`
});

export const DownPayment = createComponent('span', {
  className: `${commonClass} h-20 w-[100px] mb-20`
});

export const ShippingInfo = createComponent('span', {
  className: `${commonClass} h-16 w-[80%]`
});
